import { HireCreatorResponseDto } from '../../../common/general-types/hire-response.dto';
import { AlertService } from '../../../atoms/alert/alert.service';
import { WalletService } from '../../../services/wallet/wallet.service';
import { BriefResponseDto } from '../../../common/general-types/briefs.dto';

type HireFundsFailure = HireCreatorResponseDto & {
  success?: boolean;
  message?: string;
};

export function isInsufficientFundsHireResponse(res: HireFundsFailure | null | undefined): boolean {
  if (!res) {
    return false;
  }
  return res.hasInsufficientFunds === true || res.success === false;
}

export function isInsufficientFundsHireError(err: unknown): boolean {
  if (!err || typeof err !== 'object') {
    return false;
  }

  const httpErr = err as { status?: number; error?: HireFundsFailure | string };
  const body = httpErr.error;
  if (body && typeof body === 'object' && isInsufficientFundsHireResponse(body)) {
    return true;
  }

  // Production hire returns HTTP 402 Payment Required when the wallet cannot cover the hire.
  if (httpErr.status === 402) {
    return true;
  }

  const message = typeof body === 'string'
    ? body
    : body && typeof body === 'object' && typeof body.message === 'string'
      ? body.message
      : '';
  return httpErr.status === 400 && message.toLowerCase().includes('insufficient');
}

export async function openTopUpDrawerForInsufficientFunds(
  walletService: WalletService,
  alertService: AlertService,
  brief?: Pick<BriefResponseDto, 'businessAccountId' | 'businessAccount'>,
  onConfirm?: () => void,
): Promise<void> {
  const shouldTopUp = await alertService.confirm({
    title: 'Insufficient funds',
    message: 'You do not have enough funds in your wallet to hire this creator. Please top up to continue.',
    confirmText: 'Top Up',
    cancelText: 'Cancel',
    type: 'confirm',
    icon: 'warning',
  });

  if (!shouldTopUp) {
    return;
  }

  onConfirm?.();

  const businessAccountId = brief?.businessAccountId ?? brief?.businessAccount?.id;
  walletService.openTopUpDrawer(businessAccountId ? {
    businessAccountId,
    currencyCode: brief?.businessAccount?.currencyCode,
    companyName: brief?.businessAccount?.companyName,
  } : null);
}
